import React, { useCallback, useEffect, useState } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { changeLanguage } from '../store/actions/languageActions'
import { changeSidenav } from 'src/store/actions/sidenavAction'
import { getRedirectUrl, removeUserDetails, storage } from 'src/lib/utils'
import Helpline from 'src/pages/Helpline'
import CustomModal from './CustomModal'
import { Link } from 'react-router-dom'
import { changeTitle } from 'src/store/actions/titleActions'

function Header() {
  const data = useSelector((state) => state.generalData)
  const language = useSelector((state) => state.language)

  const attorney = [
    { text: data.txt_changesignuptext, path: '/attorney/editprofile' },
    { text: data.txt_changeusername, path: '/attorney/changeusername' },
    { text: data.txt_changepasswordtext, path: '/attorney/changepassword' },
  ]
  const alliedAttorney = [
    { text: data.txt_changesignuptext, path: '/attorney/editalliedprofile' },
    { text: data.txt_changeusername, path: '/attorney/changeusername' },
    { text: data.txt_changepasswordtext, path: '/attorney/changepassword' },
  ]
  const about = [
    { text: data.txt_ourmissiontext, path: '/ourmission' },
    { text: data.txt_whowearetext, path: '/whoweare' },
    // { text: data.txt_advisoryboardtext, path: '/advisoryboard' },
    { text: data.txt_tocindytext, path: '/tocindy' },
    { text: data.txt_contacttext, path: '/contact' },
  ]

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname, state } = useLocation()
  const location = pathname.split('/')
  const { isSaymore } = state || false
  const hash = useLocation().hash
  const [smaller, setSmaller] = useState(false)
  const [dropdown, setDropdown] = useState([])
  const sidenav = useSelector((state) => state.sidenav)
  const [showModal, setShowModal] = useState(false)
  const [open, setOpen] = useState(false)
  const role = window.sessionStorage.getItem('role')
  const token = window.sessionStorage.getItem('token')
  const isAllied = window.sessionStorage.getItem('isAllied')
  const path = location[2]
  const client = useCallback(() => {
    return [
      { text: data.txt_changesignuptext, path: '/client/editprofile' },
      { text: data.txt_changepasswordtext, path: '/client/changepassword' },
      { text: data.txt_gotomaptext, path: `/client/${getRedirectUrl()}` },
      { text: data.txt_deletemaptext, path: '/client/deleteintake' },
    ]
  }, [location.pop(), data])
  const handleLanguage = (e) => {
    const language = e.target.value
    dispatch(changeLanguage(language))
    localStorage.setItem('language', language)
  }

  const handleSidenav = (sidenav) => {
    dispatch(changeSidenav(!sidenav))
  }

  const handleOpen = (sidenav) => {
    if (sidenav) {
      document.body.classList.add('open')
    } else {
      document.body.classList.remove('open')
    }
  }

  const handleLogout = () => {
    storage.clear()
    dispatch(changeTitle({}))
    removeUserDetails()
    handleSidenav(true)
    navigate('/login', { replace: true, state: { isCurrent: 'logOut' } })
  }

  useEffect(() => {
    handleOpen(sidenav)
  }, [sidenav])

  useEffect(() => {
    if (['intake', 'facesheet', 'presection', 'messages'].includes(path)) {
      if (isSaymore) {
        handleSidenav(true)
        setOpen(false)
      } else {
        setOpen(true)
        handleSidenav(false)
      }
    } else {
      handleSidenav(true)
      setOpen(false)
    }
  }, [path])

  useEffect(() => {
    const handleScroll = () => {
      setSmaller(window.scrollY > 200)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  useEffect(() => {
    if (role === 'C') {
      setDropdown(client())
    } else if (role === 'A' && isAllied === 'false') {
      setDropdown(attorney)
    } else {
      setDropdown(alliedAttorney)
    }
  }, [role, isAllied, client, data, language])
  useEffect(() => {
    const collapseElements = document.getElementsByClassName('body-collapse')
    if (collapseElements.length > 0) {
      collapseElements[0].classList.remove('show')
    }
  }, [location])
  useEffect(() => {
    if (hash === '#helpline') setShowModal(true)
  }, [hash])

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg navbar-light fixed-top py-0 ${smaller ? 'smaller' : ''}`}
      >
        <div className={`container ${open && !sidenav ? 'header-padding' : ''}`}>
          {open && (
            <button
              className="sectionlink m-show"
              style={{ lineHeight: '27px' }}
              onClick={() => handleSidenav(sidenav)}
            >
              Menu
            </button>
          )}
          <div className={`navbar-brand ${smaller ? 'mb-3' : 'mt-0'}`}>
            <NavLink className="logo" to="/">
              Defense Map
            </NavLink>
            <span className="logocaption" dangerouslySetInnerHTML={{ __html: data.txt_tagline }} />
          </div>

          <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            className={`navbar-collapse  ${window.innerWidth <= 768 ? 'collapse body-collapse' : ''}`}
            id="navbarNavDropdown"
          >
            <div className="nav navbar-nav ms-auto navbar-nav d-flex flex-md-row flex-column ms-5">
              <ul
                className={`nav navbar-nav pt-2 z-1  ${open && !sidenav ? 'header-margin' : ''}`}
                style={{ paddingBottom: '2px' }}
              >
                <li>
                  <NavLink to="/samplereports">{data.txt_samplereports}</NavLink>
                </li>
                <li>
                  <NavLink to="/faqs">{data.txt_faq}</NavLink>
                </li>
                <li>
                  <NavLink to="#" onClick={() => setShowModal(true)}>
                    {data.txt_Helpline}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/posts">{data.txt_postslink}</NavLink>
                </li>
                <li className="dropdown about-dropdown">
                  <NavLink
                    className="dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {data.txt_aboutus} &nbsp;
                  </NavLink>
                  <Dropdown data={about} />
                </li>

                {role === 'A' && (
                  <li>
                    <NavLink to="/attorney">{data.txt_myaccounttext}</NavLink>
                  </li>
                )}
              </ul>
              <div
                className="register-wrap register-wrap-desktop"
                style={{ marginBottom: token ? '19px' : '13px' }}
              >
                <div className="clearfix">
                  <div className="login-btn">
                    {token ? (
                      <div className="login-btn logout">
                        <div className="float-start usericon">
                          <span>
                            <i className="fas fa-user" />
                          </span>
                        </div>
                        <div
                          className={`${role !== 'N' ? 'float float-start' : 'float float-start mt-2'}`}
                        >
                          <div type="button" className="btn-log" onClick={handleLogout}>
                            {data.txt_logout}
                          </div>
                          {role !== 'N' && (
                            <div className="dropdown">
                              <Link
                                href="#"
                                className="dropdown-toggle"
                                role="button"
                                id="dropdownMenuLink"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <span className="me-3 manage-icon">
                                  <i className="fas fa-user" />
                                </span>
                                {data.txt_updateprofile}&nbsp;
                              </Link>
                              <Dropdown data={dropdown} />
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="login-btn">
                        <NavLink to="/login">
                          <span dangerouslySetInnerHTML={{ __html: data.txt_login }} />
                        </NavLink>
                      </div>
                    )}
                  </div>

                  <div className="lang">
                    Language/Idioma:
                    <select id="ddllanguage" onChange={handleLanguage} value={language}>
                      <option value={1}>English</option>
                      <option value={2}>Spanish</option>
                    </select>
                  </div>
                  {open && (
                    <button
                      type="button"
                      className="sectionlink sectionlink-desktop navbar-toggle m-hide user-nav"
                      onClick={() => handleSidenav(sidenav)}
                    >
                      <span className="icon-bar mb-1" />
                      <span className="icon-bar mb-1" />
                      <span className="icon-bar" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <CustomModal
        show={showModal}
        onHide={() => setShowModal(false)}
        bodyContent={<Helpline onHide={() => setShowModal(false)} />}
        size={'xl'}
      />
    </>
  )
}

export default Header

const Dropdown = ({ data }) => {
  return (
    <ul className="dropdown-menu">
      {data.map((value, index) => (
        <li key={index}>
          <Link to={value.path} className="dropdown-item">
            {value.text}
          </Link>
        </li>
      ))}
    </ul>
  )
}

Dropdown.propTypes = {
  data: PropTypes.array.isRequired,
}
